import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useModeloNavegacao = () => {
  const history = useHistory();
  const handleRowClick = useCallback(row => {
    history.push(`/pages/modelo/detalhes/${row.id}`);
  }, [history]);
  const handleAdicionar = useCallback(() => {
    history.push('/pages/modelo/modelo/criar');
  }, [history]);
  const handleEditar = useCallback(id => {
    history.push(`/pages/modelo/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
